<template>
  <div class="mt-3 main-theme bg-white-border p-3">
    <b-table
      responsive
      striped
      hover
      class="table-list"
      :items="items"
      :fields="fields"
      :busy="isBusy"
      show-empty
      :empty-text="$t('noData')"
    >
      <template v-slot:cell(platformName)="data">
        <div class="d-flex">
          <img
            v-if="data.item.imageUrl"
            :src="data.item.imageUrl"
            width="25"
            class="mr-2"
          />
          {{ data.item.platformName }}
        </div>
      </template>
      <template v-slot:cell(isActive)="data">
        <toggle-button
          :ref="`toggle-${data.item.id}`"
          class="mt-1 mr-1"
          :value="data.item.isActive === 1 ? true : false"
          :v-model="data.item.isActive"
          :color="{
            checked: '#27BDA7',
            unchecked: '#B0B0B0',
          }"
          @change="handleChangeStatus(data.item.id)"
        />
      </template>
      <template v-slot:cell(validFrom)="data">
        <div class="d-flex justify-content-center">
          {{ data.item.isAutoSendForm ? formatDate(data.item.validFrom) : "-" }}
        </div>
      </template>
      <template v-slot:cell(validTo)="data">
        <div class="d-flex justify-content-center">
          {{ data.item.isAutoSendForm ? formatDate(data.item.validTo) : "-" }}
        </div>
      </template>
      <template v-slot:cell(randomRate)="data">
        <div class="d-flex justify-content-center">
          {{ data.item.isAutoSendForm ? data.item.randomRate : "-" }}
        </div>
      </template>
      <template v-slot:cell(id)="data">
        <div class="d-flex justify-content-center">
          <b-link class="text-link">
            <font-awesome-icon
              icon="pencil-alt"
              class="text-warning"
              title="Edit"
              @click="$emit('handleClickUpdate', data.item.id)"
            />
          </b-link>
          <b-link class="text-link ml-3">
            <font-awesome-icon
              icon="trash-alt"
              class="text-danger"
              title="Delete"
              @click="$emit('handleClickDelete', data.item.id, data.item.name)"
            />
          </b-link>
        </div> </template
    ></b-table>
    <b-row class="no-gutters px-3 px-sm-0">
      <b-col
        class="form-inline justify-content-center justify-content-sm-between"
      >
        <div v-if="rows > 0" class="my-auto">
          Showing {{ startPage | numeral("0,0") }} to
          {{ endPage | numeral("0,0") }} of {{ rows | numeral("0,0") }} entires
        </div>
        <div v-else class="my-auto">{{ rows || 0 }} entire</div>
        <div class="d-sm-flex m-3">
          <b-pagination
            v-model="filter.pageNo"
            :total-rows="rows"
            :per-page="filter.perPage"
            class="m-md-0"
            @change="$emit('pagination', $event)"
            align="center"
          ></b-pagination>
          <b-form-select
            class="select-pagination ml-md-3 w-auto"
            v-model="filter.perPage"
            @change="$emit('handleChangePerpage', $event)"
            :options="pageOptions"
          ></b-form-select>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "CastChannelSettingTable",
  props: {
    filter: {
      type: Object,
      default: () => {},
    },
    items: {
      type: Array,
      default: () => [],
    },
    isBusy: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      startPage: 1,
      endPage: 10,

      fields: [
        {
          key: "platformName",
          label: "Channel",
        },
        {
          key: "name",
          label: "Name",
          thClass: "brand-th",
        },
        {
          key: "validFrom",
          label: "Valid Form",
          thClass: "brand-th",
        },
        {
          key: "validTo",
          label: "Valid To",
          thClass: "brand-th",
        },
        {
          key: "randomRate",
          label: "Sampling Rate",
          thClass: "brand-th",
        },
        {
          key: "questionCount",
          label: "Number of Questions",
          thClass: "brand-th",
        },
        {
          key: "isActive",
          label: "Status",
          thClass: "brand-th",
        },
        {
          key: "id",
          label: "",
          thClass: "brand-th",
        },
      ],
      pageOptions: [
        { value: 10, text: `10 / Page` },
        { value: 30, text: `30 / Page` },
        { value: 50, text: `50 / Page` },
        { value: 100, text: `100 / Page` },
      ],
    };
  },

  methods: {
    pagination(Page) {
      this.filter.pageNo = Page;
    },
    handleChangePerpage(perPage) {
      this.filter.pageNo = 1;
      this.filter.perPage = perPage;
    },
    async handleChangeStatus(id) {
      const exist = this.items.find((x) => x.id == id);
      if (!exist) return false;
      const originalStatusNumber = exist.isActive == 1 ? 1 : 0;

      const originalStatus = exist.isActive == 1 ? 1 : 0;
      const newStatus = originalStatus == 1 ? 0 : 1;

      exist.isActive = newStatus;

      this.$refs[`toggle-${id}`].toggled = newStatus;

      try {
        const response = await this.axios.put(
          `${this.$baseUrl}/Csat/ch/ChangeStatus/${exist.id}/${newStatus}`
        );

        if (response && response.result == 1) {
          this.$store.commit("UPDATE_GLOBAL_ALERT", {
            isShow: true,
            msg: response.message,
          });
        } else {
          exist.isActive = originalStatus;
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
            isShow: true,
            msg: response.detail,
          });
          this.$refs[`toggle-${id}`].toggled = originalStatusNumber;
        }
      } catch (err) {
        exist.isActive = originalStatus;
        this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
          isShow: true,
          msg: err.message,
        });
        this.$refs[`toggle-${id}`].toggled = originalStatusNumber;
      } finally {
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
